import React, {useContext, useEffect, useState} from 'react';
import './style.scss';
import Tooltip from "@material-ui/core/es/Tooltip/Tooltip";
import ScheduleIcon from '@material-ui/icons/ScheduleRounded';
import SchedulerDialog from "./SchedulerDialog/SchedulerDialog";
import RouteTimeCircle from "../../../../RouteTimeCircle/RouteTimeCircle";
import moment from "moment";
import useInterval from "../../../../Utils/UseInterval";
import ErrorIcon from "@material-ui/icons/Error";
import {AppContext} from "../../../../Utils/AppContext";

const STATUSES_ALLOW_EDIT = ["ACCEPTED", "SCHEDULED_READY"];
const STATUSES_SHOW_SCHEDULE = ["ACCEPTED", "SCHEDULED_READY", "ASSIGNED_SCHEDULED_READY"];

export default function OrderStatusScheduler({order, readySla, editOrder}) {
    const appContext = useContext(AppContext);

    if (!STATUSES_SHOW_SCHEDULE.includes(order.status))
        return null;

    const [isSchedulerDialogOpen, setIsSchedulerDialogOpen] = useState(false);
    const [minutesLeft, setMinutesLeft] = useState();
    const [scheduleRatio, setScheduleRatio] = useState(0);

    useEffect(() => {
            initScheduledMinutesleft();
        },
        [order]);

    useInterval(() => {
        initScheduledMinutesleft();
    }, 2000);

    function initScheduledMinutesleft() {
        if (!order.scheduledReadyTime || !STATUSES_SHOW_SCHEDULE.includes(order.status))
            return;

        const minutesSinceScheduled = moment.duration(moment().diff(moment(new Date(order.scheduledReadyTime)))).asMinutes();
        const minutesTillReady = order.scheduledMinutesTillReady;

        if (minutesSinceScheduled >= minutesTillReady) {
            setScheduleRatio(1);
            setMinutesLeft(Math.ceil(minutesTillReady - minutesSinceScheduled))
        } else {
            setScheduleRatio(minutesSinceScheduled / minutesTillReady);
            setMinutesLeft(Math.ceil(minutesTillReady - minutesSinceScheduled))
        }
    }

    function isTouchDevice() {
        return 'ontouchstart' in document.documentElement;
    }

    function openSchedulerDialog() {
        setIsSchedulerDialogOpen(true);
    }

    function handleCloseSchedulerDialog() {
        setIsSchedulerDialogOpen(false);
    }

    function handleChooseSchedulerMinutes(minutes) {
        const changedOrder = {
            ...order,
            status: "SCHEDULED_READY",
            minutesTillReady: minutes,
            scheduledMinutesTillReady: minutes,
            scheduledReadyTime: moment().utc().format().replace('Z', '+00:00')
        };

        editOrder(changedOrder);
        setIsSchedulerDialogOpen(false);
    }

    function handleClickSchedulerContent() {
        openSchedulerDialog();
    }

    function handleOnClick(e) {
        if (!isTouchDevice() && allowEdit)
            handleClickSchedulerContent();
    }

    function handleOnTouchEnd(e) {
        if (allowEdit)
            handleClickSchedulerContent();
    }

    function renderRouteTimeCircleContent(minutes) {
        if (minutes === 1) {
            return (
                <React.Fragment>
                    <div className="pie-chart-text-description">
                        דקה
                    </div>
                </React.Fragment>
            )
        }

        return (
            <React.Fragment>
                <div className="pie-chart-text-value">
                    {minutes}
                </div>
                <div className="pie-chart-text-description">
                    דקות
                </div>
            </React.Fragment>
        )
    }

    const isReadySlaPassed = readySla !== undefined && readySla !== null && order.status === 'ACCEPTED' && moment.duration(moment().diff(moment(new Date(order.orderTime)))).asMinutes() >= readySla

    const allowEdit = STATUSES_ALLOW_EDIT.includes(order.status) && order.location && order.bid === appContext.bid;

    return (
        <React.Fragment>
            <div
                className={"order-status-scheduler " + (order.status === "ACCEPTED" ? "order-status-scheduler-accepted" : "") + (!allowEdit ? ' order-status-scheduler-no-edit' : '') + (isReadySlaPassed && allowEdit ? " order-status-scheduler-ready-sla-passed" : "")}>
                {
                    order.isCanceled && order.status === "ACCEPTED" ?
                        <Tooltip disableHoverListener={!allowEdit}
                                 disableTouchListener={!allowEdit}
                                 disableFocusListener={true}
                                 arrow
                                 title={"ההזמנה בוטלה ע״י Yango"}>
                            <span className="order-previous-status-canceled">
                                <ErrorIcon fontSize="small"/>
                            </span>
                        </Tooltip>
                        :
                        false
                }
                <div className="order-status-scheduler-content"
                     onClick={handleOnClick}
                     onTouchEnd={handleOnTouchEnd}>
                    <Tooltip disableHoverListener={!allowEdit}
                             disableTouchListener={!allowEdit}
                             disableFocusListener={true}
                             arrow
                             title={"תזמון זמן ההכנה"}>
                        {
                            order.status === "ACCEPTED" ?
                                <div className="order-status-scheduler-icon-container">
                                    <div
                                        className='order-status-scheduler-icon-button'>
                                        <ScheduleIcon fontSize={'large'}/>
                                    </div>
                                </div>
                                :
                                <div className="order-status-scheduled">
                                    <RouteTimeCircle color={"#ffb733"} status={"SCHEDULED"} totalDuration={100}
                                                     durationTillFinish={100 - Math.floor(scheduleRatio * 100)}>
                                        {renderRouteTimeCircleContent(minutesLeft)}
                                    </RouteTimeCircle>
                                </div>
                        }
                    </Tooltip>
                </div>
            </div>
            <SchedulerDialog isOpen={isSchedulerDialogOpen}
                             onCloseDialog={handleCloseSchedulerDialog}
                             onChooseMinutes={handleChooseSchedulerMinutes}/>
        </React.Fragment>
    );
}
